style= require('./team-sources.styl')

section.controls
  .panel
    .control
      if seasons
          ft-dropdown.dropdown(icon)
            header.dropdown-header(slot="header")
              if this.sport
                .dropdown-icon
                  ft-icon(name=`sports--${this.sport}`)
              span.dropdown-text=(this.sport) || 'All sports'
            each s in activeSeasons
              .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
                if s
                  .dropdown-icon
                    ft-icon(name=`sports--${s}`)
                span= s
      sporty-seasons(
        sport= this.sport,
        season=season,
        (change:season)=changeSeason(e),
        blank="<select a season>")
    .control
      ft-button(success, (click)=this.autoAssign())='Matching'
      if season?.lastTeamsUpdate
        -var by = season?.lastMatchesUpdate?.by?.email
        -var at = season?.lastMatchesUpdate?.at
        ft-icon.bell(name='ui--notification_solid')
        .last-update
          if by
            .by= by
          if at
            .at= moment(at).format('lll')
      ft-button.confirm(primary, disabled=$isSubmitting, (click)=this.save())='Save'
.panel
    label='Show N/A'
    ft-toggle(
    checked=this.showNa,
    (change)=this.toggleShowNa()
  )
section.teams-info
  .field.entries
    .title
      .counter
        .name='Existing teams'
        .count.sourced= sortedTeams.length
      ft-form-control.search(
        type='search',
        (input)=this.updateFilter(e),
        placeholder='Team')
    if sortedTeams.length > 0
      each team in sortedTeams
        - var custom = this.customSource(team)
        if showNa || !custom || !custom.notAvailable
          .entry(data-team=team._id)
            ft-clipboard.id
              span= team._id
              span.match-icon
                ft-icon(name=`ui--clipboard`)
            .header
              = custom?.name || team.name
              if custom?.abbr || team.abbr
                .tag= ' (' + (custom?.abbr || team.abbr) + ')'
              if custom?.tag || team.tag
                .tag= ' #' + (custom?.tag || team.tag)
            .sources
              ft-button(success, (click)=this.openModal(team))='Override'
              each source in this.sources(team)
                sporty-card(
                  class={dragged: source.$isDragged}
                  obj-id=source._id
                  obj-class="TeamSource"
                  keys='["source", "priority", "uid", "name"]')
    else
      .no-players
        ft-icon(name='ui--match')
        .text= 'No teams to display'
  .field.new-entries(scroll=showScroll)
    .title
      .counter
        .name='New teams'
        .count.new= newTeams.length
      if newTeams.length > 0
        ft-button.undo(danger, (click)=this.clear())='Undo'
    each source in newTeams
      sporty-card(
        class={dragged: source.$isDragged}
        obj-id=source._id
        obj-class="TeamSource"
        header="name"
        keys='["source", "uid"]')
    .submit((click)=this.openModal(-1))
      .plus= '+'
      .add= 'Add new team'
  .field.unassigned
    .title
      .counter
        .name='Unassigned teams'
        .count.no-source= nonSources.length
      section.search
        select.selector((change)=this.source = e.target.value || null)
          option(value='')="<All Sources>"
          each source in uniqueSeasonSources
            option(value=source._id)= source.source
        ft-button(success, (click)=this.assignNew())='Auto-assign'
    if nonSources.length > 0
      each source in nonSources
        sporty-card(
          class={dragged: source.$isDragged}
          obj-id=source._id
          obj-class="TeamSource"
          header="name"
          keys='["source", "uid"]')
    else
      .no-players
        ft-icon(name='ui--match')
        .text= 'No teams to display'
